<template>
  <!-- 启明星工程 -->
  <div class="qimingxing">
    <PublicCert :logo="Logo3" :type="'qmx'" :color="'#36b9bf'" />
  </div>
</template>

<script>
import PublicCert from '../component/certQuery.vue'
import Logo3 from '@/assets/images/logo3.png'

export default {
  name: 'QiMingXing',
  components: {
    PublicCert
  },
  data() {
    return {
      Logo3
    }
  }
}
</script>
